import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'clsx';

import { selectIsPaymentMethodOnInstallmentsActive } from 'app/store/data/quotationResult';
import { DictionaryEntry } from 'app/services/dict.service';
import { ReactComponent as DocIcon } from 'app/assets/icons/doc.svg';
import { ReactComponent as DownloadIcon } from 'app/assets/icons/download.svg';
import { DocumentsControlProps } from './DocumentsControl.interfaces';

const DocumentsControl: React.FunctionComponent<DocumentsControlProps> = ({
  classes,
  onClick,
  dictionary,
}) => {
  const isPaymentMethodOnInstallmentsActive = useSelector(
    selectIsPaymentMethodOnInstallmentsActive
  );

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={classNames(classes.root, {
        [classes.newStyleRoot]: isPaymentMethodOnInstallmentsActive,
      })}
    >
      {dictionary &&
        dictionary.map((row: DictionaryEntry) => (
          <a
            href={row.value as string}
            onClick={handleClick}
            target={'_blank'}
            className={classes.doc}
            key={row.key.toString()}
            rel="noopener noreferrer"
          >
            {isPaymentMethodOnInstallmentsActive ? (
              <DownloadIcon aria-hidden={true} />
            ) : (
              <DocIcon aria-hidden={true} />
            )}
            <span>{row.key}</span>
          </a>
        ))}
    </div>
  );
};

export default DocumentsControl;
